<div [hidden]="!isLoading">
  <mat-progress-spinner
    mode="indeterminate"
    [strokeWidth]="2"
    [diameter]="22 * size"
  ></mat-progress-spinner>
  <span class="message font-weight-bold">{{ message }}</span>
</div>
